export default {"src":"/uk/_next/static/media/icon-hide.213c0661.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};